import script from "./CollectionEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__